import React, { useState } from 'react'
import Spinner from '../spinner'
import styled from 'styled-components'

const StyledImg = styled.img`
  display: ${({ isFetched }) => isFetched ? 'block' : 'none'};
`

const Image = ({ alt, src }) => {
  const [isFetched, setIsFetched] = useState(false)

  return (
    <>
      <StyledImg
        src={src}
        alt={alt}
        isFetched={isFetched}
        onLoad={() => setIsFetched(true)}
      />
      {!isFetched && <Spinner />}
    </>
  )
}

export default Image
